export enum QuizzType {
  QCM = 'qcm',
  ILLUSTRATION = 'illustration',
}

export enum QuizzMedal {
  NONE = 'none',
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
}

export interface QuizzIllustrationUserAnswer {
  targetId: number
  answerId: number
}

export interface QuizzAnswer {
  id: number
  answer: string
}

export type QuizzJustificationItem = string | string[]

export interface QuizzJustification {
  items: QuizzJustificationItem[]
  references?: number[]
}

export interface QuizzSentence {
  id: number
  type: QuizzType
  question: string
  description: string
  answers: QuizzAnswer[]
  correctAnswers: number[]
  justification: QuizzJustification
}

export interface QuizzUserAnswer {
  sentenceId: number
  answersId: number[]
}
